export default {
	text: "{changedBy} changed the type of KR <a href='#' data-action='key-result'>{name}</a> from {from} to {to}",
};
